import { CourseLevelEnum } from "../../models/enums/courseLevelEnum"

export enum gender{
  Male="Male",
  Feamle="Feamle",
  Other="Other"
}

export enum source {
  Instagram = 'Instagram',
  Youtube = 'Youtube',
  Tiktok = 'Tiktok',
  School = 'School',
  Google = 'Google',
  Advertisement = 'Advertisement',
  WordOfMouth = 'WordOfMouth',
  Other = 'Other',
}


export enum country{
  India="IN",
  UK="GB",
  Canada="CA",
  USA="US",
  Other="Other"
}

export enum Step {
  emailVerification,
  setPassword,
  personalDetails,
  // genderSelection,
  // dateOfBirth,
  degreePreference,
  // intendedMajor,
  // perviousCourseCompletionOn,
  // collegeStart,
  hearAboutUs,
  // homeCountry,
  destination,
  academicsPreferences,
  journeyPreferences
}

export interface RegisterStateModel {
  emailVerification: {
    email: string,
    emailVerified: boolean
  },
  setPassword: {
    password: string,
    confirmPassword: string
  },
  personalDetails: {
    name: string
  },
  // genderSelection: {
  //   gender?: gender
  // },
  degreePreference:{
    degreePreference?: CourseLevelEnum
  },
  // intendedMajor:{
  //   intendedMajor: string
  // },
  // dateOfBirth: {
  //   bornOn: {
  //     day: string,
  //     month: string,
  //     year: string
  //   }
  // },
  // perviousCourseCompletionOn: {
  //   perviousCourseCompletionOn: string
  // },
  // collegeStart: {
  //   collegeStartOn: string
  // },
  hearAboutUs: {
    source?: source[]
  },
  // homeCountry: {
  //   homeCountry?: country
  // },
  destination: {
    destination?: country[]
  },
  academicsPreferences: {
    academics: string[],
    studentLife: string[],
    costAndOutcomes: string[]
  },
  journeyPreferences: {
    journey: string[]
  },
  currentStep: Step,
  temporaryToken: string
}

